import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcus G.',
    loc: '📍 Sydney | Head Performance Coach',
    quote: 'Finally, a resource that speaks the language of a modern club pro. I organized my 9-month junior and adult academy programming in a single afternoon. I never thought a resource could be this complete.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Florida | Professional Coach',
    quote: "My sessions finally have a solid, professional structure. I don't spend Sunday nights on YouTube anymore. Having everything ready gave me my free time back."
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Spain | PTR Certified Coach',
    quote: 'The "3-6-10 System" saved me. I never arrived on court unprepared again, even when the group size changed at the last minute. My players stay active and engaged.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Toronto | Academy Director',
    quote: 'Running a full academy and having every session coordinated is a dream. The Clear Cue Bank changed the way my students understand the toughest strokes.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Buenos Aires | Tennis Coach',
    quote: 'My groups are far more focused. The analogies in the Cue Bank really work. What I value most is that everything is organized by season block.'
  }, {
    initials: 'VT',
    name: 'Valerie T.',
    loc: '📍 London | Professional Coach',
    quote: 'The ready-made blueprints with built-in assessments save me at least 3 hours a week. It is like having an expert colleague who already did all the heavy lifting for me.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-243">
      <div className="max-w-6xl mx-auto" data-id="element-244">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-20 max-w-4xl mx-auto leading-tight" data-id="element-245">
          WHAT COACHES WHO ALREADY HAVE{' '}
          <span className="text-brand-accent" data-id="element-246">TENNIS READY SAY:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-247">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-248">
              <div className="flex items-center gap-5 mb-8" data-id="element-249">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-250">
                  {test.initials}
                </div>
                <div data-id="element-251">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 stars" data-id="element-252">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-253">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-254">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-255">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}